// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".q-card[data-v-5a84e28d]{padding:15px 30px}.q-card .title[data-v-5a84e28d]{font-size:20px;letter-spacing:.29px}.q-card .input[data-v-5a84e28d],.q-card .title[data-v-5a84e28d]{margin-bottom:32px}.q-card .image[data-v-5a84e28d]{margin-left:2rem}.toggle[data-v-5a84e28d]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
